import { createContext, useContext } from 'react';
import { SiteInspectionNavigatorContextProps } from './types';

export const SiteInspectionNavigatorContext =
  createContext<SiteInspectionNavigatorContextProps>(null as any);

export const useSiteInspectionNavigatorContext = () => {
  return useContext(SiteInspectionNavigatorContext);
};
